import React from "react";
import { BasicChequeredBoard } from "../../components/BasicChequeredBoard";
import { BasicChequeredBoardProps } from "../../components/BasicChequeredBoard/BasicChequeredBoard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export interface DistributedGenerationOverviewPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  chequeredBoard?: BasicChequeredBoardProps;
  faqs?: FaqAccordionGroupProps;
}

export const DistributedGenerationOverviewPage: React.FC<DistributedGenerationOverviewPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  chequeredBoard,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {chequeredBoard && <BasicChequeredBoard {...chequeredBoard} />}
    </ServiceCataloguePageWrapper>
  );
};
